import { ref, reactive } from 'vue'
interface typeItem {
  title: string
  description: string
  code: string | number
}
interface typeList {
  default: typeItem[]
  loudspeaker: typeItem[]
  gift: typeItem[]
  message: typeItem[]
}
export default function uesPopup() {
  const data: typeList = {
    default: [
      {
        title: '系統忙碌中',
        description: '請稍後再試',
        code: ''
      }
    ],
    loudspeaker: [
      {
        title: '活動已結束！',
        description: '我們將不定期舉辦抽獎贈禮</br>活動 敬請期待',
        code: ''
      },
      {
        title: '大量用戶湧入抽好禮</br>請稍後再試',
        description: '',
        code: ''
      },
      {
        title: '請先登入會員',
        description: '登入家樂福會員，點擊轉盤抽好禮',
        code: ''
      }
    ],
    gift: [
      {
        title: '恭喜！獲得折扣碼',
        description: '(description)',
        code: ''
      },
      {
        title: '恭喜！獲得好康點數 (point) 點',
        description: '(description)',
        code: ''
      },
      {
        title: '恭喜！獲得儲值金 (point) 元',
        description: '(description)',
        code: ''
      }
    ],
    message: [
      {
        title: '哎呀！真可惜！',
        description: '好可惜沒有抽到! 活動期間內每天都可以開啟APP參加輪盤轉轉樂~',
        code: ''
      },
      {
        title: '哎呀！真可惜！',
        description: '今日的抽獎機會用完嘍！</br>明天登入再繼續！',
        code: ''
      },
      {
        title: '抽獎機會已用完',
        description: '',
        code: ''
      },
      {
        title: '紅包已抽完',
        description: '',
        code: ''
      },
      {
        title: '活動尚未開始',
        description: '',
        code: ''
      },
      {
        title: '活動已結束',
        description: '',
        code: ''
      },
      {
        title: '哎呀！再接再厲！',
        description: '(description)',
        code: ''
      }
    ]
  }
  let dataIndex: typeItem = reactive({
    title: '',
    description: '',
    code: ''
  })
  let isDisplay = ref(false)
  let popupTypeName = ref('default')
  function closePopup() {
    dataIndex.title = ''
    dataIndex.description = ''
    dataIndex.code = ''
    popupTypeName.value = 'default'
    isDisplay.value = false
  }
  function openPopup(
    typeName: 'loudspeaker' | 'gift' | 'message' | 'default' = 'default',
    kindNumber: number = 0,
    point: number | string = -1,
    description: string = '未設定',
    code: number | string = ''
  ) {
    popupTypeName.value = typeName
    dataIndex.title = data[typeName][kindNumber].title.replace(
      '(point)',
      point.toString()
    )
    dataIndex.description = data[typeName][kindNumber].description.replace(
      '(description)',
      description.toString()
    )
    dataIndex.code = code
    isDisplay.value = true
  }
  return {
    isDisplay,
    dataIndex,
    popupTypeName,
    openPopup,
    closePopup
  }
}
